import { publishCustomerSessionRefreshed } from "./customerSession.ts"
import { service, team } from "@kestrel/bundle-metadata";
import { captureError } from "@otto-ec/global-resources/apm"

export async function refreshByOwt() {
    try {
        const response = await fetch("/session-maintenance/refresh", {
            credentials: 'include',
            headers: {
                'from-js': 'true'
            }
        });
        if (response.ok) {
            const hasCustomerSession = response.headers.get('Has-Customer-Session') == "true";
            publishCustomerSessionRefreshed({ hasCustomerSession })
        }
    } catch (e) {
        captureError(
            e as Error,
            { service, team },
            { type: "session-refresh-request-by-owt-failed" },
        );
    }
}
